/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './builder-setup-user-details.module';
export * from './builder-setup-user-details-routing.module';
